export default function validateIsinStatus(newStatus: string, exists: boolean, onlyDtiFieldsChanged: boolean = false) {
    // see also StatusValidator::validateTransition in Java

    // A NEW ISIN may stay NEW while only the DTI-controlled fields (digitalAssetStatus,
    // equivalentDigitalTokenGroup, digitalTokenIdentifiers) are being added/updated - e.g. by
    // ROLE_DNA, which is not permitted to change isinStatus at all. As soon as any other ISIN
    // field is edited, the status must move away from NEW as before.
    if (newStatus === 'N' && exists && !onlyDtiFieldsChanged) {
        return 'anna.validation.wrongIsinStatusNew';
    }
    if ((newStatus === 'U' || newStatus === 'D' || newStatus === 'I') && !exists) {
        return 'anna.validation.wrongIsinStatusNewIsin';
    }
    return undefined;
}